import React, { useEffect, useState } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import BootstrapTable from "react-bootstrap-table-next";
import Cookies from 'universal-cookie';
import html2pdf from 'html2pdf.js'; 
import InputField from "components/UI/Input/InputField";
import useValidator from '../../hooks/useValidator';
import ButtonField from "components/UI/Button/ButtonField";
import { FetchAPI } from "api/fetch";
import { PostAPI } from "api/post";
import swal from "sweetalert";


const CommonForm = ({ formElementsArray, formValues, setModalformValues, dropDownApi, saveEndPoint, setIsCommonForm,getLatestTableData }) => {
    const [validator, showValidationMessage] = useValidator();
    let [tableList, setTableList] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const cookies = new Cookies();

    const generatePDF = (name) => {
        const content = document.getElementById('pdf-content');
        html2pdf(content, {
            margin: 10,
            filename: `${name}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        });
        setIsLoader(false)
    };

    const inputModalChangedHandler = (event, inputIdentifier) => {
        const inputTypes = ["input", "select"]
        const updateOrderForm = {
            ...formValues
        }
        if (inputTypes.includes(updateOrderForm[inputIdentifier].elementType)) {
            updateOrderForm[inputIdentifier].value = event.target.value;
        } else if (updateOrderForm[inputIdentifier].elementType === 'selectshowsearch') {
            updateOrderForm[inputIdentifier].value = event
        }
        setModalformValues(updateOrderForm)
    }

    const updateDropdown = async (getURL) => {
        const updateOrderForm = {
            ...formValues
        }
        setIsLoader(true);
        const getData = await FetchAPI(getURL);
        const response = await getData.json(getData);
        setIsLoader(false);
        for (let identifier in updateOrderForm) {
            for (let dropdownKey in response.data) {
                updateOrderForm[dropdownKey].elementConfig.options = response.data[dropdownKey]
            }
        }
        setModalformValues(updateOrderForm)
    }

    const submitForm = async () => {
        let searchFormData = {};
        if (validator.allValid()) {
            for (let identifier in formValues) {
                if (formValues[identifier].elementType === "selectshowsearch") {
                    searchFormData[identifier] = formValues[identifier].value.value;
                } else {
                    searchFormData[identifier] = formValues[identifier].value
                }
            }
            const location_id = cookies.get('userLocation_id')
            searchFormData["location_id"] = location_id;
            setIsLoader(true);
            const response = await PostAPI(saveEndPoint, searchFormData);
            switch (response.data.data.status) {
                case 1:
                    swal({ title: "Success", text: response.data.data.message,icon: "success" })
                    setIsCommonForm(false);
                    getLatestTableData()
                    break;
                case 2:
                    setColumns(response.data.data.columns)
                    setRowData(response.data.data.data)
                    swal({ title: "Warning", text: response.data.data.message, icon: "warning" })
                    break
                default:
                    swal({ title: "Error", text: response.data.data.message, icon: "warning" })
            }
            setIsLoader(false);
        } else {
            showValidationMessage(true)
        }

    }

    useEffect(() => {
        if (dropDownApi != undefined) {
            updateDropdown(dropDownApi)
        }
    }, [dropDownApi])

    useEffect(() => {
        setModalformValues(formValues)
        return() => {
            const resetFormValues = {...formValues};
            for(let identifier in formValues){
                resetFormValues[identifier].value = "";
            }
            setModalformValues(resetFormValues)
        }
    },[])

    return (
        <>
        <div className="grid-commonform-container">
            {(formElementsArray?.length > 0) && (
                <div className="commonform-container">
                    {formElementsArray.map(formElement => (
                        <div className="commonform-item" >
                            <InputField
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                labelName={formElement.config.label}
                                id={formElement.config.id}
                                isValidate={formElement.config.validate}
                                changed={(event) => inputModalChangedHandler(event, formElement.id)}
                                validater={validator}
                                readonly={formElement.config.elementConfig.readonly}
                                show={formElement.config.show}
                                checked={formElement.config.checked}
                                name={formElement.config.name}
                                title="Support"
                                tableList={tableList}
                            />
                        </div>

                    ))}
                </div>
            )}
            </div>

            <div className="common-form-submit" >
                <ButtonField color="info" key="submit" disabled={isLoader} submit={() => submitForm()} BName={"Submit"} />
                {rowData.length > 0 && <ButtonField color="info" key="gen-pdf" disabled={isLoader} submit={() => generatePDF("bom-po-creation")} BName={"Download PDF"} />}
            </div>
            {rowData.length > 0 && (
                <div id="pdf-content" >
                <BootstrapTable
                    keyField="id"
                    data={rowData}
                    columns={columns}
                    striped
                    hover
                    condensed
                    bordered={false}
                    wrapperClasses="table-responsive overflow-class"
                    headerClasses="grid-header"
                />
                </div>
            )}
            {isLoader && <div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div> }
        </>
    )
}

export default CommonForm;